/* eslint-disable import/order */
import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { PaymentInfoWrapper } from './style'
import { MINIMAL_AUTHORIZATION_AMOUNT } from 'Rentlio/utils/saferpayMinimalAuthorizationAmount'
import { getPaymentPageWalletsArray, getPaymentPageMethodsArray } from 'Rentlio/utils/saferpayPaymentPageOptions'
import { getCardNumberIssuer } from 'Rentlio/utils/cardNumber'
import { getOfferErrors, getPaymentDetails } from 'Rentlio/screen/offerPayment/util/getOfferDetails'
import { scrollTo } from 'Rentlio/utils/scrollTo'
import { getOfferNoticeText } from 'Rentlio/utils/bookingTypeEnum'
import Checkbox from 'Rentlio/components/UI/Checkbox'
import {
  CheckboxWrapper,
  BookNowButton,
  BookNowWrapper,
  Link,
  PaymentInformation,
  SpinnerOverlay
} from 'Rentlio/screen/payment/components/Payment/PaymentInfo/style'
import BookingErrors from 'Rentlio/screen/payment/containers/bookingErrors'
import {
  isSaferpayPaymentPage,
  BE_BANK_TRANSFER,
  BE_MONRI,
  BE_STRIPE,
  BE_M2PAY,
  BE_WSPAY,
  BE_CREDIT_CARD,
  BE_SAFERPAY
} from 'Rentlio/utils/paymentTypesEnum'
import { getValidationErrors } from 'Rentlio/helper/validator'
import PaymentMethod from 'Rentlio/screen/offerPayment/components/OfferPayment/PaymentInfo/PaymentMethod'
import { Title } from 'Rentlio/screen/offerPayment/components/OfferPayment/style'
import { LanguageContext } from 'Rentlio/context/LanguageContext'
import { getCheckInHoursOptions } from 'Rentlio/utils/checkInHoursParser'
import { CountriesEnum } from 'Rentlio/utils/countriesEnum'
import Email from 'Rentlio/components/Icons/email'
import Phone from 'Rentlio/components/Icons/phone'
import { FormError, FormGroup, FormLabel, FormRow, FormTitle } from 'Rentlio/components/UI/form'
import { Input } from 'Rentlio/components/UI/input'
import InputWithIcon from 'Rentlio/components/UI/InputWithIcon'
import Select from 'Rentlio/components/UI/Select'
import { Textarea } from 'Rentlio/components/UI/textarea'
import Animation from 'Rentlio/components/UI/Animation'
import Spinner from 'Rentlio/components/UI/Spinner'
import rentlioLocalStorage from 'Rentlio/helper/rentlioLocalStorage'
import { getScheduledOfferPaymentsPayload } from 'Rentlio/helper/scheduledPayments/getScheduledPaymentsPayload'
import { DIRECT } from 'Rentlio/utils/scheduledPaymentTypeEnum'
import isRentlioPayEnabled from '../../../../../helper/scheduledPayments/helpers/isRentlioPayEnabled'
import { removeQueryParameter } from 'Rentlio/utils/url'

class PaymentInfo extends Component {
  static contextType = LanguageContext
  state = {
    firstName: '',
    lastName: '',
    companyName: '',
    companyVatId: '',
    email: '',
    phone: '',
    country: '',
    address: '',
    city: '',
    postalCode: '',
    estimatedTimeOfArrival: '',
    note: '',
    cardholderName: '',
    cardNumber: '',
    cvv: '',
    expirationDate: '',
    cardholderSameAsGuest: true,
    termsAccepted: false,
    clickedOnce: false,
    loading: false,
    selectedPaymentMethod: BE_BANK_TRANSFER,
    selectedPaymentMethodSettings: {},
    errors: {},
    isCompany: false,
    termsRead: false,
    isEmptyMonri: false,
    hasScroll: false,
    isReturnFromPaymentPage: false,
    isNewsletterSubscribed: false,
    bookingErrorMessage: null
  }

  componentDidMount = () => {
    const { booker, offerUuid } = this.props.offer

    const isCompany = !booker.isGuest

    this.setState({
      firstName: booker.firstName ?? '',
      lastName: booker.lastName ?? '',
      companyName: booker.name ?? '',
      companyVatId: booker.legalId ?? '',
      email: booker.email ?? '',
      phone: booker.phone ?? '',
      address: booker.addres ?? '',
      country: booker.countryId ?? '',
      isCompany: isCompany,
      isNewsletterSubscribed: booker.isNewsletterSubscribed ?? false
    })

    this.fillSelectedPaymentMethod()
    this.fillStateFromLocalStorage()

    const urlParams = new URLSearchParams(window.location.search)
    const isSaferpayPaymentPageRedirect = urlParams.get('saferpay-payment-page-redirect') === 'true'
    const paymentPageToken = rentlioLocalStorage.get('payment-page-token')
    const paymentPagePublicId = rentlioLocalStorage.get('payment-page-public-id')
    rentlioLocalStorage.remove('payment-page-token')
    rentlioLocalStorage.remove('payment-page-public-id')

    if (isSaferpayPaymentPageRedirect && paymentPageToken) {
      this.setState({ loading: true }, () => {
        const guestDetails = this.getGuestDetailsFromState()
        const paymentDetails = this.getOfferPaymentDetails(paymentPageToken, paymentPagePublicId)

        this.acceptOffer(offerUuid, this.props.booking.code, guestDetails, paymentDetails)
          .then(res => {
            if (res.response?.error) {
              this.setState({ loading: false })
            }
          })
          .finally(() => {
            // drop the redirect marker but keep the rest of the query - `currency` holds the
            // guest's selected currency after the payment page redirect
            isSaferpayPaymentPageRedirect && removeQueryParameter('saferpay-payment-page-redirect')
          })
      })
    }
  }

  componentDidUpdate = prevState => {
    if (prevState.locale !== this.props.locale) {
      this.setState({ termsRead: false, termsAccepted: false })
    }
  }

  getValidationError = key => getValidationErrors(this.state.errors, key)

  onTermsAcceptClicked = () => {
    const { selectedPaymentMethod, termsRead, hasScroll, isEmptyMonri } = this.state
    const isSaferpayPayment = isSaferpayPaymentPage(selectedPaymentMethod)
    // Only allow toggling termsAccepted if terms are read or don't need to be scrolled through
    const shouldRequireTermsRead =
      hasScroll &&
      (selectedPaymentMethod === BE_MONRI ||
        selectedPaymentMethod === BE_WSPAY ||
        (selectedPaymentMethod === BE_CREDIT_CARD && isEmptyMonri) ||
        selectedPaymentMethod === BE_SAFERPAY ||
        isSaferpayPayment)

    if (shouldRequireTermsRead && !termsRead) {
      return // Prevent checking if terms aren't read
    }

    this.setState(prevState => ({ termsAccepted: !prevState.termsAccepted }))
  }

  onNewsletterClicked = () => {
    this.setState(prevState => ({ isNewsletterSubscribed: !prevState.isNewsletterSubscribed }))
  }

  getTosCheckboxContent = () => {
    const { translate } = this.context
    const { openTermsOfServiceModal, openPrivacyPolicyModal, isEmptyMonri } = this.props
    const { termsRead, selectedPaymentMethod } = this.state

    const shouldReadTerms =
      selectedPaymentMethod === BE_MONRI ||
      selectedPaymentMethod === BE_WSPAY ||
      (selectedPaymentMethod === BE_CREDIT_CARD && isEmptyMonri)

    return !shouldReadTerms || (shouldReadTerms && termsRead) ? (
      <>
        {translate('BookNowTOS')} <Link onClick={openTermsOfServiceModal}>{translate('Terms of service')}</Link>{' '}
        {translate('and')} <Link onClick={openPrivacyPolicyModal}>{translate('Privacy policy')}</Link>
      </>
    ) : (
      <>
        {translate('BookNowTOS')} {translate('Terms of service')} {translate('and')} {translate('Privacy policy')}
      </>
    )
  }

  filteredPaymentMethods = () => {
    const { paymentMethods, receipt } = this.props

    const filteredPaymentMethods = paymentMethods.map(method => {
      if (Number(method.id) === BE_MONRI && !method.settings.authenticityToken) {
        this.setState({ isEmptyMonri: true })
        return { ...method, id: BE_CREDIT_CARD, settings: null }
      }
      return method
    })

    return filteredPaymentMethods.filter(item => item.bookingEngineId === receipt.bookingEngineId)
  }

  fillSelectedPaymentMethod = () => {
    const filteredPaymentMethods = this.filteredPaymentMethods()
    if (filteredPaymentMethods.length === 0) {
      return
    }

    this.setState({ selectedPaymentMethod: filteredPaymentMethods[0].id })

    if (filteredPaymentMethods[0].settings) {
      this.setState({ selectedPaymentMethodSettings: filteredPaymentMethods[0].settings })
    }
  }

  fillStateFromLocalStorage = () => {
    const guestDetails = rentlioLocalStorage.get('booker')

    if (guestDetails) {
      this.setState({ ...guestDetails, isReturnFromPaymentPage: true }, () => rentlioLocalStorage.remove('booker'))
    }
  }

  getCurrency = () => this.props.booking.reservations[0].currency

  getPrepaymentDetails = () => {
    const {
      booking: { reservations }
    } = this.props
    return { prepaymentAmount: reservations.map(res => res.prepaymentAmount).reduce((a, b) => a + b, 0) }
  }

  getGuestDetailsFromState = () => {
    const {
      firstName,
      lastName,
      companyName,
      companyVatId,
      email,
      phone,
      country,
      address,
      city,
      postalCode,
      estimatedTimeOfArrival,
      note,
      isCompany,
      isNewsletterSubscribed
    } = this.state

    return {
      firstName,
      lastName,
      companyName,
      companyVatId,
      email,
      phone,
      country,
      address,
      city,
      postalCode,
      estimatedTimeOfArrival,
      note,
      isCompany,
      isNewsletterSubscribed
    }
  }

  getOfferPaymentDetails = (token, publicId) => {
    const { receipt } = this.props

    const {
      firstName,
      lastName,
      companyName,
      selectedPaymentMethod,
      cardholderSameAsGuest,
      cardholderName,
      expirationDate,
      cvv,
      cardNumber,
      isCompany
    } = this.state

    // Scheduled payment amounts sent to the backend (and to SaferPay authorization) are the raw
    // receipt amounts in the property's main currency - the backend validates and charges in that
    // currency only. The guest-selected currency is used for display purposes exclusively.
    const scheduledPayments = getScheduledOfferPaymentsPayload(receipt, this.isAutoPayEnabled())

    return getPaymentDetails(
      selectedPaymentMethod,
      cardholderSameAsGuest,
      firstName,
      lastName,
      cardholderName,
      expirationDate,
      cvv,
      cardNumber,
      isCompany,
      companyName,
      token,
      scheduledPayments,
      publicId
    )
  }

  book = () => {
    const { termsAccepted, selectedPaymentMethod, termsRead, isNewsletterSubscribed } = this.state

    const {
      offer: { offerUuid },
      booking: { code }
    } = this.props

    const guestDetails = this.getGuestDetailsFromState()
    this.setState({ loading: true })

    // If Bank Transfer is selected add only payment method type
    const payment = this.getOfferPaymentDetails()
    // Maybe we can solve this better, if bank transfer is selected DO NOT add CreditCard details to validation
    // because we won't be able to Book
    const errors = getOfferErrors(selectedPaymentMethod, guestDetails, payment, termsAccepted)

    if (errors !== true) {
      this.setState({ errors, loading: false })
      scrollTo(document.documentElement, 0, 500)
      return
    } else {
      this.setState({ errors: {} })
    }

    if (selectedPaymentMethod === BE_MONRI || selectedPaymentMethod === BE_WSPAY) {
      // This is ONE TIME ONLY HACK - we wanted to  keep  monri stuff  in monri component - do not do this again
      return (
        this.paymentMethodsRef.monriPayment && this.paymentMethodsRef.monriPayment.submitPayment(guestDetails, payment)
      )
    }
    if (selectedPaymentMethod === BE_STRIPE) {
      return this.paymentMethodsRef.stripePayment && this.paymentMethodsRef.stripePayment.onBookPressed()
    }
    if (selectedPaymentMethod === BE_M2PAY) {
      return (
        this.paymentMethodsRef.m2payPayment && this.paymentMethodsRef.m2payPayment.onBookPressed(guestDetails, payment)
      )
    }
    if (selectedPaymentMethod === BE_SAFERPAY) {
      return (
        this.paymentMethodsRef.saferpayPayment &&
        this.paymentMethodsRef.saferpayPayment.onBookPressed(guestDetails, payment)
      )
    }

    if (isSaferpayPaymentPage(selectedPaymentMethod)) {
      rentlioLocalStorage.add('booker', {
        ...guestDetails,
        selectedPaymentMethod,
        termsRead,
        termsAccepted,
        isNewsletterSubscribed
      })
      this.handlePaymentPageOpen(selectedPaymentMethod)
      return
    }

    this.acceptOffer(offerUuid, code, guestDetails, payment)
  }

  acceptOffer = (offerUuid, code, guestDetails, payment) => {
    return this.props.acceptBookingOffer(offerUuid, code, { guestDetails, payment }).then(({ success, response }) => {
      this.setState({ loading: false })
      if (!success) {
        return
      }

      window.location.replace(`/reservations/${response.publicId}`)
    })
  }

  isAutoPayEnabled = () => {
    const { paymentMethods } = this.props

    return paymentMethods?.some(pm => pm?.settings?.isAutoPayEnabled)
  }

  handlePaymentPageOpen = selectedPaymentMethod => {
    const { offer, booking, saferpayPaymentPageInitialize, bookingEngine, receipt } = this.props

    let prepaymentAmount = MINIMAL_AUTHORIZATION_AMOUNT

    const scheduledPayments = getScheduledOfferPaymentsPayload(receipt)
    const prepaymentAmountCents = +scheduledPayments[0]?.type === DIRECT ? scheduledPayments[0]?.amountCents : null
    prepaymentAmount =
      isRentlioPayEnabled() && prepaymentAmountCents ? prepaymentAmountCents / 100 : MINIMAL_AUTHORIZATION_AMOUNT

    saferpayPaymentPageInitialize({
      amount: prepaymentAmount,
      currency: bookingEngine.currency,
      bookingEngineId: bookingEngine.id,
      paymentPageWallets: getPaymentPageWalletsArray(selectedPaymentMethod),
      paymentPageMethods: getPaymentPageMethodsArray(selectedPaymentMethod),
      offerUuid: offer.offerUuid,
      code: booking.code,
      guestEmail: this.state.email
    }).then(res => {
      if (res.success) {
        const { RedirectUrl, Token, PublicId } = res.response
        rentlioLocalStorage.add('payment-page-token', Token)
        rentlioLocalStorage.add('payment-page-public-id', PublicId)
        window.location.replace(RedirectUrl)
      } else {
        this.setState({ loading: false })
      }
    })
  }

  setData = object => this.setState({ ...object })

  termsScrolledThrough = () => {
    this.setState({ termsRead: true })
  }

  setHasScroll = () => {
    this.setState(prevState => {
      // Only reset termsRead if not returning from a payment page where it was already true
      const shouldResetTermsRead = !prevState.isReturnFromPaymentPage || !prevState.termsRead
      return {
        hasScroll: true,
        termsRead: shouldResetTermsRead ? false : prevState.termsRead
      }
    })
  }

  setTermsRead = read => {
    this.setState({ termsRead: read })
  }

  shouldDisableCheckbox = () => {
    const { isEmptyMonri } = this.state
    const { termsRead, selectedPaymentMethod, hasScroll } = this.state
    const isSaferpayPayment = isSaferpayPaymentPage(selectedPaymentMethod)
    const shouldShowTerms =
      hasScroll &&
      (selectedPaymentMethod === BE_MONRI ||
        selectedPaymentMethod === BE_WSPAY ||
        isSaferpayPayment ||
        selectedPaymentMethod === BE_SAFERPAY ||
        (selectedPaymentMethod === BE_CREDIT_CARD && isEmptyMonri))

    return shouldShowTerms && !termsRead
  }

  render() {
    const { translate } = this.context

    const {
      firstName,
      lastName,
      companyName,
      companyVatId,
      email,
      phone,
      country,
      estimatedTimeOfArrival,
      note,
      termsAccepted,
      selectedPaymentMethod,
      cardNumber,
      isCompany,
      loading,
      termsRead,
      isEmptyMonri,
      hasScroll,
      isNewsletterSubscribed,
      bookingErrorMessage
    } = this.state

    const cardIssuer = getCardNumberIssuer(cardNumber)
    const {
      paymentMethods,
      offer,
      booking,
      paymentDetails,
      updatePaymentInfo,
      paymentGateways,
      getMonriClientSecret,
      getStripeClientSecret,
      receipt,
      acceptBookingOffer,
      getM2PayClientSecret,
      openM2Pay3DSModal,
      locale,
      bookingEngine,
      openSaferpay3DSModal,
      saferpayAliasInsert,
      saferpayTransactionInitialize
    } = this.props
    const { booker } = offer

    const filteredPaymentMethods = paymentMethods.map(method => {
      if (Number(method.id) === BE_MONRI && !method.settings.authenticityToken) {
        return { ...method, id: BE_CREDIT_CARD, settings: method.settings }
      }
      return method
    })

    return (
      <>
        <Animation show={loading} animationType={'fadeInOut'} isModal>
          <SpinnerOverlay>
            <Spinner width={70} disableScroll color={'#07587A'} />
          </SpinnerOverlay>
        </Animation>

        <PaymentInfoWrapper>
          <FormTitle>
            <Title>{translate('Booker details')}</Title>
          </FormTitle>
          {isCompany ? (
            <FormRow>
              <FormGroup>
                <FormLabel>
                  <label htmlFor='companyName'>{translate('Company name')}</label>
                </FormLabel>
                <Input
                  id='companyName'
                  value={companyName}
                  onChange={e => {
                    this.setState({ companyName: e.target.value })
                  }}
                  disabled={!!booker.name}
                />
                <FormError>{this.getValidationError('companyName')}</FormError>
              </FormGroup>
              <FormGroup>
                <FormLabel>
                  <label htmlFor='companyVatId'>{translate('Company VAT id')}</label>
                </FormLabel>
                <Input
                  id='companyVatId'
                  value={companyVatId}
                  onChange={e => {
                    this.setState({ companyVatId: e.target.value })
                  }}
                  disabled={!!booker.legalId}
                />
                <FormError>{this.getValidationError('companyVatId')}</FormError>
              </FormGroup>
            </FormRow>
          ) : (
            <FormRow>
              <FormGroup>
                <FormLabel>
                  <label htmlFor='firstName'>{translate('First name')}</label>
                </FormLabel>
                <Input
                  id='firstName'
                  value={firstName}
                  onChange={e => {
                    this.setState({ firstName: e.target.value })
                  }}
                  disabled={!!booker.firstName}
                />
                <FormError>{this.getValidationError('firstName')}</FormError>
              </FormGroup>
              <FormGroup>
                <FormLabel>
                  <label htmlFor='lastName'>{translate('Last name')}</label>
                </FormLabel>
                <Input
                  id='lastName'
                  value={lastName}
                  onChange={e => {
                    this.setState({ lastName: e.target.value })
                  }}
                  disabled={!!booker.lastName}
                />
                <FormError>{this.getValidationError('lastName')}</FormError>
              </FormGroup>
            </FormRow>
          )}
          <FormRow>
            <FormGroup>
              <FormLabel>
                <label htmlFor='eMail'>E-mail</label>
              </FormLabel>
              <InputWithIcon
                idForInput='eMail'
                icon={<Email />}
                value={email}
                onChange={e => {
                  this.setState({ email: e.target.value })
                }}
                disabled={!!booker.email}
              />
              <FormError>{this.getValidationError('email')}</FormError>
            </FormGroup>
            <FormGroup>
              <FormLabel>
                <label htmlFor='phone'>{translate('Phone')}</label>
              </FormLabel>
              <InputWithIcon
                idForInput='phone'
                icon={<Phone />}
                value={phone}
                onChange={e => {
                  this.setState({ phone: e.target.value })
                }}
                disabled={!!booker.phone}
              />
              <FormError>{this.getValidationError('phone')}</FormError>
            </FormGroup>
          </FormRow>
          <FormRow>
            <FormGroup>
              <FormLabel>
                <label htmlFor='country'>{translate('Country')}</label>
              </FormLabel>

              <Select
                id='country'
                ref={node => (this.selectCountry = node)}
                placeholder='Select country'
                options={CountriesEnum}
                selected={country}
                selectOption={item => {
                  this.setState({ country: item.value })
                }}
                enableSearch
                disabled={!!booker.countryId}
              />
              <FormError>{this.getValidationError('country')}</FormError>
            </FormGroup>
            <FormGroup>
              <FormLabel onClick={this.showEstimatedTimeOfArrivalDropdown}>
                <label htmlFor='estimatedTimeOfArrival'>{translate('Estimated time of arrival')}</label>
              </FormLabel>
              <Select
                id='estimatedTimeOfArrival'
                ref={node => (this.estimatedTimeOfArrival = node)}
                selected={estimatedTimeOfArrival}
                options={getCheckInHoursOptions()}
                selectOption={item => {
                  this.setState({ estimatedTimeOfArrival: item.value })
                }}
                enableSearch
              />
              <FormError>{this.getValidationError('estimatedTimeOfArrival')}</FormError>
            </FormGroup>
          </FormRow>
          <FormRow>
            <FormGroup fullWidth={true}>
              <FormLabel>
                <label htmlFor='message'>{translate('Message')}</label>
              </FormLabel>
              <Textarea
                id='message'
                value={note}
                onChange={e => {
                  this.setState({ note: e.target.value })
                }}
              />
            </FormGroup>
          </FormRow>
          <PaymentMethod
            ref={node => (this.paymentMethodsRef = node)}
            inputData={{ ...this.state, cardIssuer }}
            paymentMethods={filteredPaymentMethods}
            getValidationError={this.getValidationError}
            setData={this.setData}
            currency={this.getCurrency()}
            prePaymentDetails={this.getPrepaymentDetails()}
            paymentDetails={paymentDetails}
            updatePaymentInfo={updatePaymentInfo}
            paymentGateways={paymentGateways}
            getMonriClientSecret={getMonriClientSecret}
            getStripeClientSecret={getStripeClientSecret}
            getM2PayClientSecret={getM2PayClientSecret}
            openM2Pay3DSModal={openM2Pay3DSModal}
            bookingEngine={bookingEngine}
            receipt={receipt}
            acceptBookingOffer={acceptBookingOffer}
            bookingCode={booking.code}
            offerUuid={offer.offerUuid}
            locale={locale}
            termsAccepted={termsAccepted}
            termsScrolledThrough={this.termsScrolledThrough}
            termsRead={termsRead}
            isEmptyMonri={isEmptyMonri}
            booking={booking}
            offer={offer}
            setHasScroll={this.setHasScroll}
            hasScroll={hasScroll}
            setTermsRead={this.setTermsRead}
            openSaferpay3DSModal={openSaferpay3DSModal}
            saferpayAliasInsert={saferpayAliasInsert}
            saferpayTransactionInitialize={saferpayTransactionInitialize}
            selectedPaymentMethod={selectedPaymentMethod}
          />
          {!getOfferNoticeText(offer, booking) && (
            <>
              <CheckboxWrapper>
                <Checkbox
                  isChecked={termsAccepted}
                  click={this.onTermsAcceptClicked}
                  text={this.getTosCheckboxContent()}
                  disabled={this.shouldDisableCheckbox()}
                />
                <Checkbox
                  isChecked={isNewsletterSubscribed}
                  click={this.onNewsletterClicked}
                  text={translate('Yes, I would like to receive special offers and news.')}
                  disabled={this.shouldDisableCheckbox()}
                />
              </CheckboxWrapper>
              <BookNowWrapper>
                <BookNowButton onClick={this.book} enabled={termsAccepted && !loading}>
                  {translate('Book now')}
                </BookNowButton>
                <FormError>{this.getValidationError('termsAccepted')}</FormError>
              </BookNowWrapper>
              <BookingErrors errorMessage={bookingErrorMessage} />
              {BE_BANK_TRANSFER !== selectedPaymentMethod &&
                BE_MONRI !== selectedPaymentMethod &&
                BE_WSPAY !== selectedPaymentMethod && (
                  <PaymentInformation>{translate('PaymentInformationNotice')}</PaymentInformation>
                )}
              {(BE_MONRI === selectedPaymentMethod || BE_WSPAY === selectedPaymentMethod) && (
                <PaymentInformation>{translate('PaymentInformationMonri')}</PaymentInformation>
              )}
            </>
          )}
        </PaymentInfoWrapper>
      </>
    )
  }
}

PaymentInfo.propTypes = {
  paymentMethods: PropTypes.array,
  openTermsOfServiceModal: PropTypes.func,
  openPrivacyPolicyModal: PropTypes.func,
  booking: PropTypes.object,
  offer: PropTypes.object,
  acceptBookingOffer: PropTypes.func,
  updatePaymentInfo: PropTypes.func,
  paymentDetails: PropTypes.object,
  paymentGateways: PropTypes.object,
  getMonriClientSecret: PropTypes.func,
  getStripeClientSecret: PropTypes.func,
  receipt: PropTypes.object,
  bookingEngine: PropTypes.object,
  getM2PayClientSecret: PropTypes.func,
  openM2Pay3DSModal: PropTypes.func,
  locale: PropTypes.string,
  isEmptyMonri: PropTypes.bool,
  openSaferpay3DSModal: PropTypes.func,
  saferpayAliasInsert: PropTypes.func,
  saferpayPaymentPageInitialize: PropTypes.func,
  saferpayTransactionInitialize: PropTypes.func
}

export default PaymentInfo
